module.exports = __webpack_public_path__ + "img/cropped-tyrel-johnson-qzOAhs1cYn4-unsplash-compressed-small.b43fb793.webp";